module.exports = __webpack_public_path__ + "img/useful-material-element-2.ca42fd17.png";